import React from "react";
import "../styles/carousel.css"; // Mantendo o CSS caso precise de ajustes

const VideoComponent = () => {
  return (
    <div className="video-container" style={{ position: "relative", width: "100%", height: "500px" }}>
      <iframe
        width="100%"
        height="500"
        src="https://www.youtube.com/embed/PGkuHe74TrA?autoplay=1&mute=1&loop=1&playlist=PGkuHe74TrA"
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      ></iframe>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.3)"
      }}></div>
    </div>
  );
};

export default VideoComponent;
